import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, } from 'redux';
import { push, } from 'react-router-redux';
import * as classNames from 'classnames';
import { feathersAuthentication } from 'src/feathers';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/index.css';
import Dropdown from 'antd/lib/dropdown';
import Icon from 'antd/lib/icon';
import Menu from 'antd/lib/menu';
import 'antd/lib/dropdown/style/index.css';
import 'antd/lib/menu/style/index.css';
var selfStyles = require('./HeaderItemProfile.scss');
var HeaderItemProfile = function (props) {
    if (!props.store.user) {
        return null;
    }
    return (React.createElement(Dropdown, { trigger: ['click'], overlay: (React.createElement(Menu, null,
            React.createElement(Menu.Item, null,
                React.createElement("div", { className: selfStyles.menuText, onClick: function () {
                        props.actions.handleLogoutRequest();
                        props.actions.handleNavigate('/');
                    } },
                    React.createElement(Icon, { type: 'logout', className: selfStyles.menuIcon }),
                    React.createElement("span", null, "Log Out"))))) },
        React.createElement("div", { className: classNames(selfStyles.profile, (_a = {}, _a[selfStyles.profileAdmin] = props.store.user.isAdmin, _a)) },
            React.createElement("div", { className: selfStyles.profileImage }, props.store.userProfile && props.store.userProfile.avatar ? (React.createElement(Avatar, { shape: 'square', size: 'large', src: props.store.userProfile.avatar })) : (React.createElement(Avatar, { shape: 'square', size: 'large', icon: 'user' }))),
            React.createElement("div", { className: selfStyles.profileText },
                React.createElement("span", null, props.store.userProfile ? props.store.userProfile.name : 'CRIMP User'),
                React.createElement("span", null, props.store.userProfile ? props.store.userProfile.email : 'unknown@crimp.rocks')))));
    var _a;
};
var mapStateToProps = function (state) { return ({
    store: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        userProfile: state.workspaceMain.userProfile && state.workspaceMain.userProfile.data[0],
    },
}); };
var mapDispatchToProps = function (dispatch) { return ({
    actions: bindActionCreators({
        handleLogoutRequest: feathersAuthentication.logout,
        handleNavigate: push,
    }, dispatch),
}); };
export default connect(mapStateToProps, mapDispatchToProps)(HeaderItemProfile);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/HeaderItemProfile.tsx
// module id = 357
// module chunks = 0